import React from "react";
import {BrowseCategoriesProps} from "@/elements-react/browse-categories";

export const BrowseCategoriesDefault: React.FC<BrowseCategoriesProps> = () => {
    return(<></>);
};
